import React from "react";

const WidgetSeleccionFecha = (props) => {
    const enviarMensajeComoUsuario = (texto, handler) => {
        props.setState((prevState) => ({
            ...prevState,
            messages: [...prevState.messages, {message: texto, type: "user"}],
        }));
        handler();
    };

    const fechas = props.payload || [];
    return (
        <div className="chat-options-container" style={{gap: "10px"}}>
            {fechas.map((fecha, index) => (
                <button
                    key={index}
                    className="fecha-button"
                    onClick={() =>
                        enviarMensajeComoUsuario("fecha:" + fecha, () =>
                            props.actionProvider.manejarFlujoVenta("fecha:" + fecha)
                        )
                    }
                >
                    {fecha}
                </button>
            ))}
        </div>
    );
};

export default WidgetSeleccionFecha;
